export function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
}
export function radiansToDegrees(radians) {
    return radians * (180 / Math.PI);
}
export function DistanceVec2(a, b) {
    return Math.hypot(b[0] - a[0], b[1] - a[1]);
}
export function rayIntersectVertical(A, xLine, f) {
    const [x0, y0] = A;
    const degToRad = f; //* Math.PI / 180
    const cosF = Math.cos(degToRad);
    const sinF = Math.sin(degToRad);
    // луч параллелен линии
    if (Math.abs(cosF) < 1e-9)
        return A;
    const t = (xLine - x0) / cosF;
    // если нужен именно ЛУЧ, а не прямая
    if (t < 0)
        return A;
    const y = y0 + t * sinF;
    return [xLine, y];
}
export function rayIntersectHorizontal(A, yLine, f) {
    // A = [x1, y1]
    // y2 = горизонтальная прямая y = y2
    // f = угол луча в радианах (от оси X)
    const degToRad = f; //* Math.PI / 180
    const [x1, y1] = A;
    const sin = Math.sin(degToRad);
    const cos = Math.cos(degToRad);
    if (Math.abs(sin) < 1e-9)
        return A;
    const t = (yLine - y1) / sin;
    // если нужен именно ЛУЧ, а не прямая
    if (t < 0)
        return A;
    return [
        x1 + t * cos,
        yLine
    ];
}
function rotatePoint([x, y], angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return [
        x * cos - y * sin,
        x * sin + y * cos
    ];
}
export function getOffsetsAfterRotation(lines, angle) {
    // 1️⃣ Сначала находим bbox исходных линий
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const line of lines) {
        for (const [x, y] of line) {
            if (x < minX)
                minX = x;
            if (x > maxX)
                maxX = x;
            if (y < minY)
                minY = y;
            if (y > maxY)
                maxY = y;
        }
    }
    const cx = (minX + maxX) / 2;
    const cy = (minY + maxY) / 2;
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    // 2️⃣ Вращаем все точки вокруг центра bbox
    let rMinX = Infinity;
    let rMaxX = -Infinity;
    let rMinY = Infinity;
    let rMaxY = -Infinity;
    for (const line of lines) {
        for (const [x, y] of line) {
            // сдвиг в центр
            const dx = x - cx;
            const dy = y - cy;
            // поворот
            const rx = dx * cos - dy * sin + cx;
            const ry = dx * sin + dy * cos + cy;
            if (rx < rMinX)
                rMinX = rx;
            if (rx > rMaxX)
                rMaxX = rx;
            if (ry < rMinY)
                rMinY = ry;
            if (ry > rMaxY)
                rMaxY = ry;
        }
    }
    return {
        // насколько сместился левый край
        deltaLeft: Math.abs(rMinX - minX),
        // правый
        deltaRight: Math.abs(rMaxX - maxX),
        // нижний
        deltaBottom: Math.abs(rMinY - minY),
        // верхний
        deltaTop: Math.abs(rMaxY - maxY),
        width: rMaxX - rMinX,
        height: rMaxY - rMinY,
        rMinY: rMinY,
        rMaxY: rMaxY,
        rMinX: rMinX,
        rMaxX: rMaxX,
    };
}
export function distanceBetweenPoints(A, B) {
    const dx = B[0] - A[0];
    const dy = B[1] - A[1];
    return Math.hypot(dx, dy);
}
export function distanceBetweenPoints3D(A, B) {
    const dx = B[0] - A[0];
    const dy = B[1] - A[1];
    const dz = B[2] - A[2];
    return Math.hypot(dx, dy, dz);
}
export function getCoordinateOnDiagonal(a, offset) {
    const angle = degreesToRadians(a);
    const dZ = -Math.cos(angle) * offset;
    const dY = -Math.sin(angle) * offset;
    return { dY: dY, dZ: dZ };
}
export function pointFromAngle(p, a, l) {
    const [x, y] = p;
    // const degToRad = a * Math.PI / 180
    return [
        x + Math.cos(a) * l,
        y + Math.sin(a) * l,
    ];
}
